import { alpha } from "@mui/system";

const useStyles = (theme) => ({
  textDataPicker: {
    fontSize: "0.875rem",
    fontWeight: 500,
    fontColor: theme.palette.text.primary,
  },
  titleDataPicker: {
    fontSize: "0.875rem",
    fontWeight: 500,
    color: theme.palette.text.secondary,
  },
  dataTime: {
    actionBar: {
      actions: ["accept"],
      sx: {
        "& .MuiButton-root": {
          color: theme.palette.easyLog.primary, // Cor do texto
          backgroundColor: "transparent", // Cor de fundo
          "&:hover": {
            backgroundColor: alpha(theme.palette.easyLog.primary, 0.05), // Cor de fundo ao passar o mouse
          },
        },
      },
    },
    accept: {
      sx: {
        backgroundColor: "#4CAF50", // Cor verde para o botão Aceitar
        color: "white",
        "&:hover": {
          backgroundColor: "#45a049", // Cor verde mais escuro no hover
        },
        borderRadius: "5px",
      },
    },
    digitalClockSectionItem: {
      sx: {
        borderRadius: "4px",
        "&.Mui-selected": {
          backgroundColor: theme.palette.easyLog.primary,
          color: "#fff",
        },
        "&.Mui-selected:hover": {
          backgroundColor: theme.palette.easyLog.secondary,
        },
      },
    },
    day: {
      sx: {
        "&.Mui-selected:focus": {
          backgroundColor: theme.palette.easyLog.primary, // Mantém a cor ao clicar
        },
        "&.Mui-selected": {
          backgroundColor: theme.palette.easyLog.primary,
          color: "#fff",
          fontWeight: 500,
        },
        "&.Mui-selected:hover": {
          backgroundColor: theme.palette.easyLog.secondary,
        },
      },
    },
    desktopPaper: {
      sx: {
        backgroundColor: theme.palette.background.default,
        boxShadow: "0px 0px 4px 0px  rgba(0, 0, 0, 0.25)",
      },
    }, // Para desktop
    mobilePaper: {
      sx: {
        backgroundColor: theme.palette.background.paperNotification,
        boxShadow: "0px 0px 4px 0px  rgba(0, 0, 0, 0.25)",
      },
    }, // Para mobile
  },
  menuList: { height: "124px", overflow: "auto" },
  menuItem: {
    fontSize: "0.875rem",
    fontWeight: 500,
    "&:hover": {
      //  backgroundColor: alpha(theme.palette.background.textField, 0.4),
    },
    borderRadius: 1,
    "&.Mui-selected": {
      color: theme.palette.primary.main,
      backgroundColor: alpha(theme.palette.primary.main, 0.1),
      "&:hover": {
        //  backgroundColor: alpha(theme.palette.primary.main, 0.2),
      },
    },
  },
  paperPoover: {
    "& .MuiPopover-paper": {
      marginTop: "5px",
      boxShadow: "0px 4px 14px 0px  #0000002c",
      padding: "10px",
      overflow: "visible",
      borderRadius: 1,
    },
  },
});

export default useStyles;
